var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 5H6.875C5.97989 5 5.12145 5.35558 4.48851 5.98851C3.85558 6.62145 3.5 7.47989 3.5 8.375V24.125C3.5 25.0201 3.85558 25.8786 4.48851 26.5115C5.12145 27.1444 5.97989 27.5 6.875 27.5H17V29.75H13.625C13.3266 29.75 13.0405 29.8685 12.8295 30.0795C12.6185 30.2905 12.5 30.5766 12.5 30.875C12.5 31.1734 12.6185 31.4595 12.8295 31.6705C13.0405 31.8815 13.3266 32 13.625 32H22.625C22.9234 32 23.2095 31.8815 23.4205 31.6705C23.6315 31.4595 23.75 31.1734 23.75 30.875C23.75 30.5766 23.6315 30.2905 23.4205 30.0795C23.2095 29.8685 22.9234 29.75 22.625 29.75H19.25V27.5H29.375C30.2701 27.5 31.1286 27.1444 31.7615 26.5115C32.3944 25.8786 32.75 25.0201 32.75 24.125V8.375C32.75 7.47989 32.3944 6.62145 31.7615 5.98851C31.1286 5.35558 30.2701 5 29.375 5ZM6.875 7.25H29.375C29.6734 7.25 29.9595 7.36853 30.1705 7.5795C30.3815 7.79048 30.5 8.07663 30.5 8.375V19.625H5.75V8.375C5.75 8.07663 5.86853 7.79048 6.0795 7.5795C6.29048 7.36853 6.57663 7.25 6.875 7.25ZM29.375 25.25H6.875C6.57663 25.25 6.29048 25.1315 6.0795 24.9205C5.86853 24.7095 5.75 24.4234 5.75 24.125V21.875H30.5V24.125C30.5 24.4234 30.3815 24.7095 30.1705 24.9205C29.9595 25.1315 29.6734 25.25 29.375 25.25Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.9be8f16e1caf24b4890aa193b57b2b68.svg";
export { ForwardRef as ReactComponent };